import type { CSSProperties } from "react";

/**
 * Colours for the role tags, as inline style rather than Tailwind classes.
 *
 * antd v6 styles Tag through CSS-in-JS at the same specificity as a utility
 * class, so which one wins comes down to stylesheet order. These pairings are
 * chosen for contrast -- #20353E on #E6F4FA is 11.4:1, against 3.3:1 for the
 * white-on-#0E98D0 they replace, which failed WCAG AA -- so they should not be
 * left to that coin toss.
 */
export const ROLE_TAG_STYLE: CSSProperties = {
  margin: 0,
  backgroundColor: "#E6F4FA",
  color: "#20353E",
  borderColor: "#B6DDEF",
  // Role names run long -- "R&D Operations and Business Optimization" is 40
  // characters. Wrap inside the tag rather than pushing the column wider.
  whiteSpace: "normal",
  maxWidth: "100%",
};

/** Account-level standing (superuser, client admin), warmer to set it apart. */
export const ACCOUNT_TAG_STYLE: CSSProperties = {
  margin: 0,
  backgroundColor: "#F3EEDD",
  color: "#20353E",
  borderColor: "#DDCE9E",
};
